import React from "react";
import { Card } from "react-bootstrap";

import { bioStyle } from "./styles";

const SkillCardItem = ({ obj }) => {
  if (!obj?.title) {
    return null;
  }

  const { title, link } = obj;
  const cardProps = link
    ? {
        as: "a",
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
      }
    : {};

  return (
    <Card
      {...cardProps}
      style={{
        display: "inline-flex",
        border: "1px solid rgba(24, 23, 22, 0.1)",
        borderRadius: "999px",
        background: "rgba(255, 255, 255, 0.72)",
        boxShadow: "0 10px 24px rgba(40, 36, 30, 0.07)",
        color: "inherit",
        textDecoration: "none",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
      }}
    >
      <div
        style={{
          padding: "8px 13px",
        }}
      >
        <p
          style={{
            ...bioStyle,
            margin: 0,
            textAlign: "center",
            whiteSpace: "nowrap",
            fontWeight: 700,
            color: "#27231f",
          }}
        >
          {title}
        </p>
      </div>
    </Card>
  );
};

export default SkillCardItem;
